<template>
  <div class="weiVCon videoD">
    <div class="trainListBox">
      <mt-navbar
        v-model="selected"
        fixed
      >
        <mt-tab-item id="taxi">巡游出租车</mt-tab-item>
        <mt-tab-item id="netCar">网约出租车</mt-tab-item>
      </mt-navbar>
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="taxi">
          <div
            v-show="isHasdata1"
            class=""
          >
            <div v-if="!isLogin">
              <router-link to="/login">
                <img
                  src="../assets/imgs/toLoginIcon.png"
                  alt=""
                  class="toLoginIcon"
                >

                <img
                  src="../assets/imgs/nonLoginTxt.png"
                  alt=""
                  class="nonLoginTxt"
                >
              </router-link>
            </div>
            <div v-if="isLogin">
              <div
                class="trainItems"
                v-for="item in classlist"
                :key="item.index"
              >
                <div class="clearfix">
                  <div class="fl">
                    <div class="trainTit">
                      <img
                        src="../assets/imgs/huangg.png"
                        alt=""
                      >
                      {{item.title}}
                    </div>
                    <p>{{item.remark}}</p>
                    <p v-if="item.isPay === 1">学习进度：{{item.mPer}}%（{{item.mNotLearn}}/{{item.mBasicsLearn}}分钟）</p>
                    <div
                      class="hasBuy isBuy"
                      v-if="item.isPay === 1"
                    >
                      <img
                        src="../assets/imgs/sure.png"
                        alt=""
                      >
                      已购买<span>（有效期至{{item.expDate!=="" && item.expDate!==null?item.expDate:""}}）</span>
                    </div>
                    <div
                      class="nonBuy isBuy"
                      v-else
                    >
                      <img
                        src="../assets/imgs/money.png"
                        alt=""
                      >
                      {{item.money}}
                    </div>
                  </div>
                  <div class="fr">
                    <mt-button
                      v-if="item.isPay===1"
                      type="default"
                      class="trainBtn btnStudy"
                      @click="toCourseList(item.year,5)"
                    >去学习</mt-button>
                    <router-link
                      v-else
                      :to="{path:'/pay',query:{planId:item.id}}"
                      class="trainBtn btnStudy"
                    >去购买</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="!isHasdata1"
            class="noData"
          >
            <img
              src="../assets/imgs/noDataIcon.png"
              alt=""
            >
            <p class="noDataTit">未查询到相关数据</p>
            <p>暂无数据，请刷新重试</p>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="netCar">
          <div
            v-show="isHasdata"
            class="noData"
          >
            <img
              src="../assets/imgs/noDataIcon.png"
              alt=""
            >
            <p class="noDataTit">未查询到相关数据</p>
            <p>暂无数据，请刷新重试</p>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <van-popup v-model="needwsBox" position="bottom">
      <van-picker
      show-toolbar
      title="请选择企业"
      :columns="cityList"
      @cancel="onCancel"
      @confirm="onConfirm"
    />
    </van-popup>
  </div>
</template>
<style scoped>
  .van-radio-group {
      display: flex;
    justify-content: space-around;
    padding: 20px;
}
.van-hairline--top-bottom{
  margin: 20px 20px 20px 0;
}
</style>
<script>
import { Toast, Indicator } from 'mint-ui'
import { getTrainlist,needws,companyList,perfect } from '../../src/api/Api'
import { mapGetters } from 'vuex'
import { Popup } from 'vant'
import { Picker } from 'vant'

export default {
  name: 'videoD',
  data () {
    return {
      classlist: [],
      isLogin: false, // 是否登录
      isHasdata: true,
      isHasdata1: true,
      selected: 'taxi',
      stuProgress: '10%',
      validHours: 10,
      basicHours: 200,
      dateEnd: '2019-10-30',
      payMoney: '140.00',
            needwsBox:false,
      cityList:[],
      yearTerm:'',
      hyTerm:0,
    }
  },
  computed: {
    ...mapGetters(['stuId', 'ProfessionId'])
  },
  created () {
    var userId = sessionStorage.getItem('userId')
    if (userId === '' || userId === null || userId === undefined) {
      this.isLogin = false
    } else {
      this.isLogin = true
      this.getTrainlists(5)
      this.$store.dispatch('SetProfessionId',5)
      sessionStorage.setItem('professionId', 5)
      this.companyList();
    }
  },
  mounted () {
    window.myVue = this
  },
  methods: {
    companyList:function(){
      var that = this;
      companyList().then(res => {
        Indicator.close();
        if (res.data.returnCode === 1) {
            var carr = res.data.returnDate;
            carr.forEach(element => {
              var co = {
                id:element.id,
                text:element.company_name
              }
              that.cityList.push(co);
            });
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    onConfirm(picker, value, index){
      debugger;
      var that = this;
      that.needwsBox = false;
      var params = {
        companyId:picker.id
      }
      Indicator.open()
      perfect(params).then(res => {
        Indicator.close();
        if (res.data.returnCode === 1) {
            this.$router.push({ path: '/vGroup', query: { year: that.yearTerm  } })
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    onCancel(){
      this.needwsBox = false;
      console.log('点击了取消按钮');
    },
    getTrainlists (t) {
      var type = 0
      Indicator.open()
      var _this = this
      getTrainlist({
        source: type,
        type: t
      }).then(res => {
        if (res.data.returnCode === 1) {
          Indicator.close()
          _this.classlist = res.data.returnDate[0].tbStudyPlans
          if (res.data.returnDate.length < 1) {
            this.isHasdata1 = false
          } else {
            this.isHasdata1 = true
          }
        } else {
          Indicator.close()
          this.isHasdata1 = false
          Toast(res.data.returnMsg)
        }
      })
    },
    toCourseList (year) {
      Toast('缴费成功请在app上面进行学习')
      // var that = this;
      // if (
      //   sessionStorage.getItem('photo') === '' ||
      //   sessionStorage.getItem('photo') === null ||
      //   sessionStorage.getItem('photo') === undefined
      // ) {
      //   Toast('未上传头像，无法学习！')
      // } else {
      //   //this.$router.push({ path: '/vGroup', query: { year: year,hyCode:hyCode } })
      //   Indicator.open()
      //   //判断是否需要完善信息
      //   needws().then(res => {
      //       Indicator.close()
      //     if (res.data.returnCode === 1) {
      //         var isBox  = res.data.returnDate;
      //         if(!isBox){
      //           this.$router.push({ path: '/vGroup', query: { year: year  } })
      //         }else{
      //           //弹出完善信息界面
      //           that.needwsBox = res.data.returnDate;
      //           // that.hyTerm = hyCode;
      //           that.yearTerm = year;
      //         }
      //     } else {
      //       Toast(res.data.returnMsg)
      //     }
      //   })

      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ContinueEdu.vue